import { Box, Button, Grid, Paper, Typography, useTheme } from "@mui/material"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import BackgroundLogo from "../../assets/elm/background.jpg"
import { deleteCurrentUser, logout } from "../features/auth/authThunks"
import { useAppDispatch } from "../hooks"

function DeleteAccount() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [isDeleted, setIsDeleted] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const [successMsg, setSuccessMsg] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const theme = useTheme()
  const isDarkMode = theme.palette.mode === "dark"

  const handleDeleteAccount = async () => {
    setIsLoading(true)
    setErrorMsg("")
    setSuccessMsg("")
    try {
      const result = await dispatch(deleteCurrentUser())
      if (deleteCurrentUser.fulfilled.match(result)) {
        setSuccessMsg("Account has been successfully deleted.")
        setIsDeleted(true)
      } else {
        setErrorMsg(result.payload || "Error occurred during account deletion.")
      }
    } catch (err) {
      setErrorMsg("Something went wrong.")
    } finally {
      setIsLoading(false)
    }
  }

  const handleLogout = () => {
    dispatch(logout())
    navigate("/")
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      width={"100%"}
      style={{
        backgroundImage: `url(${BackgroundLogo})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          borderRadius: 5,
          width: 400,
          paddingX: 3,
        }}
      >
        <Grid
          container
          textAlign={"center"}
          justifyContent={"center"}
          paddingY={2}
        >
          {" "}
          <Grid
            item
            xs={12}
            mb={2}
            mt={0}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button
              variant="text"
              disabled={isLoading}
              onClick={handleLogout}
              style={{
                fontSize: 16,
                color: isDarkMode ? "white" : theme.palette.primary.main,
              }}
            >
              X
            </Button>
          </Grid>
          <Grid item xs={12} mb={2}>
            <Typography variant="h5">Delete Account</Typography>
          </Grid>
          <Grid item xs={10} mb={1}>
            <Typography
              color={isDarkMode ? "white" : theme.palette.primary.main}
            >
              Are you sure you want to delete your account?
            </Typography>
          </Grid>
          <Grid item xs={5.5} mb={1}>
            <Button
              variant="contained"
              type="submit"
              style={{
                marginTop: 20,
                width: "100%",
                borderRadius: 6,
                marginRight: 8,
              }}
              onClick={handleDeleteAccount}
              disabled={isDeleted || isLoading}
            >
              Yes, delete
            </Button>
          </Grid>
          <Grid item xs={5.5} mb={1}>
            <Button
              variant="outlined"
              type="submit"
              style={{
                marginTop: 20,
                width: "100%",
                borderRadius: 6,
                marginLeft: 8,
                color: isDarkMode ? "white" : theme.palette.primary.main,
              }}
              onClick={handleLogout}
            >
              Cancel
            </Button>
          </Grid>
          {errorMsg && (
            <Typography variant="h6" mt={2} color={"red"}>
              {errorMsg}
            </Typography>
          )}
          {successMsg && (
            <Typography variant="h6" mt={2} color={"green"}>
              {successMsg}
            </Typography>
          )}
        </Grid>
      </Paper>
    </Box>
  )
}

export default DeleteAccount
